import Cookies from "js-cookie"
import { parseLangCookie, serializeLangPref } from "./resolve-language-redirect"
import { languagesForMarket, type Language } from "./languages"

/**
 * Persist the visitor's explicit language pick for a market. Mirrors how the
 * region selector writes `override_store`, but into `lang_pref` (the cookie
 * `resolve-language-redirect.ts` Gate 3 reads: "explicit pick wins"). Keyed by
 * BASE market. Silently ignores a language the market does not serve, so a bad
 * caller can never persist a dead slug like "de-fr".
 */
export const setLangPref = (market: string, language: Language): void => {
  if (!languagesForMarket(market).includes(language)) return
  const current = parseLangCookie(Cookies.get("lang_pref")) ?? {}
  const next = { ...current, [market]: language }
  Cookies.set("lang_pref", serializeLangPref(next), {
    path: "/",
    sameSite: "lax",
    expires: 30,
  })
}
